import { FunctionComponent } from "react";
import TopMenu from "../shared/top-menu/top-menu";
import Footer from "../shared/footer/footer";
import "./freetrial.scss";
import OurFormula from "./our-formula";
import FreeTrialForm from "./freetrial-form";
import H2 from "../shared/html-tags/h2";
import H1 from "../shared/html-tags/h1";
import DIV from "../shared/html-tags/div";
export type Props = {};

const FreeTrialSuccess: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="page freetrial">
      <TopMenu selected="freetrial"></TopMenu>
      <div className="page-content bg-top-freetrial top-banner">
        <div className="inner-content freetrial-top-banner">
          <div className="top-left" style={{ height: "unset" }}>
            <div className="top-left-2" style={{ marginLeft: "0" }}>
              <H2 language="de">
                Entdecke den Mehrwert mit PS IMAGO PRO und SPSS Statistics
              </H2>
              <H1 language="de">
                Kostenloser Download der
                <br />
                Testversion von PS IMAGO PRO
              </H1>
            </div>
          </div>
          <DIV language="de" className="top-right" style={{ display: "flex" }}>
            <img
              src="/img/freetrial/freetrial-495x500.png"
              alt="Roboter hält eine Waage mit PS IMAGO PRO und SPSS Statistics"
              style={{
                border: "none",
                marginTop: "0",
                maxHeight: "250px",
                borderRadius: "0",
              }}
            />
          </DIV>
        </div>
        <div className="inner-content">
          <div className="trial-form">
            <div className="left">
              <OurFormula fontColor="white" />

              <p style={{ marginTop: "3rem" }}>
                Erlebe die Leistungsfähigkeit von IBM SPSS Statistics in
                Kombination mit den erweiterten Funktionen von PS IMAGO PRO -{" "}
                <b>mehr Leistung bei geringeren Kosten</b>
              </p>
              <p>
                Profitiere von auf einer Software, die auf SPSS aufbaut und
                speziell entwickelte Funktionen bietet, um das volle Potenzial
                deiner Datenanalyse zu entfalten.
              </p>
            </div>
            <div className="right" style={{ paddingRight: "2rem" }}>
              <h2>Unverbindlich testen</h2>
              <div className="confirmation">
                <div className="confirmation-text">
                  <h4>
                    Vielen Dank für dein Interesse, PS IMAGO PRO zu testen
                  </h4>
                  <p>
                    Wir schicken Dir den Download-Link für die kostenlose
                    Testversion an die angegebene E-Mail Adresse.
                  </p>
                  <p>
                    Für den Test benötigst du außerdem einen Lizenzcode, den wir
                    Dir ebenfalls per E-Mail zusenden. Der Lizenzcode wird zu
                    den üblichen Bürozeiten innerhalb von 24 Stunden versendet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
};

export default FreeTrialSuccess;
